import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ReportPage from 'components/RolePatient/ReportPage';

import ReportsHistory from 'containers/ReportsHistory/PatientRole';
import Profile from 'containers/RolePatient/Profile';
import Resources from 'containers/Resources';

const PatientRoutes = () => (
  <Switch>
    <Route path="/report" component={ReportPage} />
    <Route path="/reports-history" component={ReportsHistory} />
    <Route path="/profile" component={Profile} />
    <Route path="/resources" component={Resources} />

    <Redirect to="/report" />
  </Switch>
);

export default PatientRoutes;
